import { SupervisorRating } from '@/service/types';

export type EvaluationTypes = {
  feedbackText: SupervisorRating['feedbackText'];
  feedbackType: SupervisorRating['feedbackType'];
};

export const SUPERVISOR_EVALUATION = {
  POSITIVE: 'Positive',
  NEGATIVE: 'Negative',
} as const;

export const SUPERVISOR_EVALUATION_OPTIONS = Object.values(
  SUPERVISOR_EVALUATION,
);

export const initialEvaluation: EvaluationTypes = {
  feedbackText: '',
  feedbackType: '',
};

export const PLACEHOLDER_FEEDBACK = 'Write your feedback...';
